export default __webpack_public_path__ + "static/media/Group2603.a428a49d.png";